import alt from '../alt';
import store from '../store/store';
import { openFlow } from '../actions/reduxActions/mapElements';
import GraphActions from '../actions/graph';

export class GraphStore {

    constructor() {
        this.graphs = {};
        this.isLoading = {};
        this.isSaving = {};
        this.selectedElement = {};
        this.alert = {};

        this.bindListeners({
            setLoading: GraphActions.setLoading,
            setSaving: GraphActions.setSaving,
            update: GraphActions.update,
            onGet: GraphActions.onGet,
            onSave: GraphActions.onSave,
            onError: GraphActions.onError,
            delete: GraphActions.delete,
            clearAlert: GraphActions.clearAlert,
        });
    }

    update(model) {
        if (this.graphs[model.flowId]) {
            this.graphs[model.flowId].mapElements = model.graph.mapElements;
            this.graphs[model.flowId].groupElements = model.graph.groupElements;
        }
    }

    setLoading(flowId) {
        this.isLoading[flowId] = true;
    }

    setSaving(flowId) {
        this.isSaving[flowId] = true;
    }

    onGet({ response, tenantId, authenticationToken }) {
        if (!this.graphs[response.id.id]) {
            this.graphs[response.id.id] = {};
        }

        this.graphs[response.id.id] = response;
        this.isLoading[response.id.id] = false;

        if (response.id.id && tenantId && authenticationToken) {
            store.dispatch(
                openFlow({
                    flowId: response.id.id,
                    editingToken: response.editingToken,
                    tenantId,
                    authenticationToken,
                }),
            );
        }
    }

    onSave({ response }) {
        if (this.graphs[response.id.id]) {
            this.isSaving[response.id.id] = false;
        }
    }

    onError(response) {
        if (this.graphs[response.id]) {
            this.isSaving[response.id] = false;
            this.alert[response.id] = {
                style: 'danger',
                message: response.message || response.statusText || response.error,
                icon: 'warning-sign',
            };
        }
    }

    clearAlert(id) {
        this.alert[id] = null;
    }

    delete(flowId) {
        if (this.graphs[flowId]) {
            this.graphs[flowId] = null;
            this.isSaving[flowId] = null;
            this.isDirty[flowId] = null;
            this.selectedElement[flowId] = null;
            this.alert[flowId] = null;

            delete this.graphs[flowId];
            delete this.isSaving[flowId];
            delete this.isDirty[flowId];
            delete this.selectedElement[flowId];
            delete this.alert[flowId];
        }
    }

}

export default alt.createStore(GraphStore, 'graph');
